import {
  Component,
  Input,
  ViewChild
} from '@angular/core';
import {
  ControlContainer,
  NgForm,
  NgModel
} from '@angular/forms';

import { CompanyCountryValidationsModel } from '../../../companies/models/company.country-validations';
import { PostcodeValidator }              from '../../validators/postcode.validator';
import { TextControlComponent }           from '../text-control/text-control.component';
import { trimOnBlur }                     from '../trim-on-blur';

@Component({
  selector   : 'wor-postcode-control',
  template: require('./postcode-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class PostcodeControlComponent extends TextControlComponent {
  // The AngularJS field: the value is trimmed and upper-cased, and a masked match is sent without its mask.
  @Input() isLegacy    = false;
  @Input() maxlength   = 10;
  @Input() validations : CompanyCountryValidationsModel;

  @ViewChild('postcode')        postcodeModel     : NgModel;
  @ViewChild(PostcodeValidator) postcodeValidator : PostcodeValidator;

  onBlur ( event : FocusEvent ) : void {
    if ( this.isLegacy ) {
      trimOnBlur(this.postcodeModel);
    }

    this.blur.emit(event);
  }

  onModelChange ( _model : string ) : void {
    if ( !this.isLegacy ) {
      this.modelChange.emit(_model);

      return;
    }

    const typed = ( _model || '' ).trim();

    const mask  = this.postcodeValidator?.mask;
    const regex = this.postcodeValidator?.regex;

    if ( !regex || !regex.test(typed) ) {
      this.modelChange.emit(typed);

      return;
    }

    const shown = this.postcodeValidator.format(typed).toUpperCase();

    this.modelChange.emit(mask ? shown.replace(regex, '$1$2') : shown);
  }

  isPostcodeInvalid ( model : NgModel ) : boolean {
    return (
      model.errors?.required
        && model.control.dirty
        && model.control.invalid
    ) || model.control.invalid;
  }
}
